import React, { useContext } from 'react';
import { LanguageContext } from '../App';
import { translations } from '../i18n/translations';
import { theme } from '../config/theme';

function FileModal({ file, url, onClose }) {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  if (!file || !url) return null;

  const ext = file.name.split('.').pop().toLowerCase();
  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
  const isPdf = ext === 'pdf';

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <span style={styles.filename}>{file.name}</span>
          <button onClick={onClose} style={styles.closeBtn}>✕ {t.close}</button>
        </div>
        <div style={styles.content}>
          {isPdf && <iframe src={url} style={styles.iframe} title={file.name} />}
          {isImage && <img src={url} alt={file.name} style={styles.image} />}
        </div>
        <div style={styles.footer}>
          <a href={url} download={file.name} style={styles.downloadBtn}>
            ⬇ {t.download}
          </a>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.85)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
  },
  modal: {
    backgroundColor: theme.colors.bgCard,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '10px', width: '85vw', height: '85vh',
    display: 'flex', flexDirection: 'column', overflow: 'hidden',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 20px', borderBottom: `1px solid ${theme.colors.border}`,
  },
  filename: {
    fontSize: '13px', fontWeight: '500', color: theme.colors.textPrimary,
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '70%',
  },
  closeBtn: {
    backgroundColor: 'transparent', border: `1px solid ${theme.colors.border}`,
    borderRadius: '4px', padding: '5px 12px', cursor: 'pointer',
    fontSize: '12px', color: theme.colors.textSecondary,
  },
  content: {
    flex: 1, overflow: 'auto', display: 'flex',
    alignItems: 'center', justifyContent: 'center',
    backgroundColor: theme.colors.bg,
  },
  iframe: { width: '100%', height: '100%', border: 'none' },
  image: { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' },
  footer: {
    padding: '12px 20px', borderTop: `1px solid ${theme.colors.border}`,
    display: 'flex', justifyContent: 'flex-end',
  },
  downloadBtn: {
    backgroundColor: theme.colors.white, color: theme.colors.textDark,
    border: 'none', borderRadius: '4px', padding: '7px 16px',
    cursor: 'pointer', fontSize: '12px', fontWeight: '600', textDecoration: 'none',
  },
};

export default FileModal;